import Control from './Control';
import drawArrowGroupHover from '../../img/next_grouphover.png';
import drawArrowHover from '../../img/next_hover.png';
import drawArrowPressed from '../../img/next_pressed.png';
import drawArrowRest from '../../img/next_rest.png';

export default class DrawArrow extends Control {
  constructor(store, dispatcher) {
    super({
      tooltip: 'DrawArrow (5)',
      mode: 'DrawArrow',
      srcRest: drawArrowRest,
      srcGroup: drawArrowGroupHover,
      srcHover: drawArrowHover,
      srcDown: drawArrowPressed,
    }, store, dispatcher);
  }
}